"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidV8DisplayDictionaryKeys = exports.ValidV8TypeaheadCategories = void 0;
// https://kyruus.jira.com/wiki/spaces/AHC/pages/2169144221/Search+API+v8+vs.+v9#Categories-Differences
// https://stg-searchservice-v8.kyruus.com/docs/#!/typeahead/typeahead
exports.ValidV8TypeaheadCategories = [
    'name',
    'provider_name',
    'specialty',
    'specialty_strict',
    'specialty_synonym',
    'clinical_combined',
    'clinical_experience',
    'practice_group',
    'practice_location',
    'network_affiliation',
    'primary_care',
    'primary_care_condition'
];
exports.ValidV8DisplayDictionaryKeys = [
    'searchwidget.label',
    'searchwidget.button.aria_label',
    'searchwidget.placeholder',
    'searchwidget.locationlabel',
    'searchwidget.locationplaceholder',
    'searchwidget.buttontext',
    'search.searchtypes.providername',
    'search.searchtypes.specialty',
    'search.searchtypes.clinicalcombined',
    'search.searchtypes.clinicalexperience',
    'search.searchtypes.department',
    'search.searchtypes.networkaffiliation',
    'search.searchtypes.primarycare'
];
//# sourceMappingURL=V8Config.js.map